import React from 'react';
import { NextPage } from 'next';
import { useRouter } from 'next/router';
import { Row } from '@sumup-oss/circuit-ui/legacy';

import { getPosSectionsPageStaticProps } from './sectionsStatic';

import { SectionPageProps } from 'types/components';
import SectionsList from 'components/SectionsList';
import MobileSectionsList from 'components/MobileSectionsList';
import { PageNavigation, PageContent } from 'components/styledComponents';
import SectionArticles from 'pages/sections/components/SectionArticles';

const Page: NextPage<SectionPageProps> = ({
  articles,
  sectionTree,
  sectionId,
  sectionTypeTree,
}) => {
  const router = useRouter();

  if (router.isFallback) {
    return <div>Page is loading. This is the loader to show meanwhile</div>;
  }

  return (
    <Row>
      <PageNavigation span="0" skip="0">
        <MobileSectionsList
          sectionTree={sectionTree}
          currentSection={sectionId}
          sectionTypeTree={sectionTypeTree}
          isPos
        />
        <SectionsList
          sectionTree={sectionTree}
          currentSection={sectionId}
          sectionTypeTree={sectionTypeTree}
          isPos
        />
      </PageNavigation>
      <PageContent span="0" skip="0">
        <SectionArticles
          articles={articles}
          sectionTree={sectionTree}
          currentSection={sectionId}
          isPos
        />
      </PageContent>
    </Row>
  );
};

export const getStaticProps = getPosSectionsPageStaticProps;

// eslint-disable-next-line @typescript-eslint/require-await
export const getStaticPaths = async () => ({
  paths: [],
  fallback: true,
});

export default Page;
